__turbopack_context__.v({
  "buttonInteractionWrapper": "aLJTpG_buttonInteractionWrapper",
  "container": "aLJTpG_container",
  "interactionButton": "aLJTpG_interactionButton",
});
